import { render, staticRenderFns } from "./EditPorfileView.vue?vue&type=template&id=d23c24aa&scoped=true"
import script from "./EditPorfileView.vue?vue&type=script&lang=js"
export * from "./EditPorfileView.vue?vue&type=script&lang=js"
import style0 from "./EditPorfileView.vue?vue&type=style&index=0&id=d23c24aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23c24aa",
  null
  
)

export default component.exports